function mailingList (apiConfig) {
	return {
		subscribeToMailingList (formData, succesFunc, failFunc) {
			const route = 'v1/mailing-list/'
			const rq = apiConfig.context.$http.post(
				route,
				formData,
				apiConfig.requestObj()
			)
			return apiConfig.buildPromise(rq, succesFunc, failFunc)
		}
	}
}
export default mailingList